import React, { Component } from "react";

const ZENDESK_SCRIPT_ID = "ze-snippet";
const ZENDESK_SCRIPT_URL =
  "https://static.zdassets.com/ekr/snippet.js?key=ac9e9657-1760-4172-9707-cb6e77f7c609";

const ZENDESK_ENABLED_ROUTES = [
  "/account",
  "/profile",
  "/faq",
  "/faqs",
  "/help",
  "/help-center",
  "/contact",
  "/contact-us",
  "/customer-care",
  "/support",
];

const normalizePath = (pathname) => {
  const path = (pathname || "/").toLowerCase().replace(/\/+$/, "");
  return path || "/";
};

const isZendeskEnabledPath = (pathname) => {
  const path = normalizePath(pathname);

  return ZENDESK_ENABLED_ROUTES.some(
    (route) => path === route || path.indexOf(`${route}/`) === 0,
  );
};

class ZendeskChat extends Component {
  constructor(props) {
    super(props);

    this.isInitialized = false;
    this.initializeZendesk = this.initializeZendesk.bind(this);
    this.handleMessengerOpen = this.handleMessengerOpen.bind(this);
    this.syncZendesk = this.syncZendesk.bind(this);
  }

  componentDidMount() {
    this.syncZendesk();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.pathname !== this.props.pathname) {
      this.syncZendesk();
    }
  }

  componentWillUnmount() {
    this.setMessengerVisibility(false);
  }

  getUserMetadata() {
    let user = this.props.user || {};

    if (!user.msisdn) {
      try {
        const persistedState = JSON.parse(
          sessionStorage.getItem("mobiotv") || "null",
        );
        user =
          (persistedState &&
            persistedState.AccountReducer &&
            persistedState.AccountReducer.user) ||
          user;
      } catch (error) {
        user = this.props.user || {};
      }
    }

    return [
      {
        id: "32029301330589",
        value: Intl.DateTimeFormat().resolvedOptions().timeZone,
      },
      { id: "31943203621021", value: window.location.hostname },
      { id: "5716867531933", value: user.msisdn },
    ].filter((field) => field.value != null && field.value !== "");
  }

  handleMessengerOpen() {
    if (typeof window.zE === "function") {
      window.zE(
        "messenger:set",
        "conversationFields",
        this.getUserMetadata(),
      );
    }
  }

  initializeZendesk() {
    if (typeof window.zE !== "function") return;

    if (!this.isInitialized) {
      window.zE("messenger:on", "open", this.handleMessengerOpen);
      this.isInitialized = true;
    }

    this.setMessengerVisibility(isZendeskEnabledPath(this.props.pathname));
  }

  setMessengerVisibility(isVisible) {
    if (typeof window.zE !== "function") return;

    window.zE("messenger", isVisible ? "show" : "hide");
  }

  syncZendesk() {
    if (window.location.hostname === "tr.mobiotv.com") return;

    const isEnabled = isZendeskEnabledPath(this.props.pathname);

    if (!isEnabled) {
      this.setMessengerVisibility(false);
      return;
    }

    if (typeof window.zE === "function") {
      this.initializeZendesk();
      return;
    }

    const existingScript = document.getElementById(ZENDESK_SCRIPT_ID);
    if (existingScript) {
      existingScript.addEventListener("load", this.initializeZendesk, {
        once: true,
      });
      return;
    }

    const script = document.createElement("script");
    script.id = ZENDESK_SCRIPT_ID;
    script.type = "text/javascript";
    script.async = true;
    script.src = ZENDESK_SCRIPT_URL;
    script.addEventListener("load", this.initializeZendesk, { once: true });
    document.head.appendChild(script);
  }

  render() {
    return null;
  }
}

export { isZendeskEnabledPath };
export default ZendeskChat;



// WEBPACK FOOTER //
// ./src/components/ZendeskChat/ZendeskChat.js